import { AdminMultimediaThumbVariant } from '../../../admin/enums/admin-multimedia-thumb-variant';
import { MultimediaThumbResponse } from '../responses/multimedia-thumb.response';

export const getMiniThumbUrl = (thumbs: MultimediaThumbResponse[]) => {
  const [thumb] = thumbs.filter(
    (thumb) => thumb.variant === AdminMultimediaThumbVariant.Mini,
  );

  return thumb.url;
};
